import { render, staticRenderFns } from "./IconUser.vue?vue&type=template&id=40f3b02e"
import script from "./IconUser.vue?vue&type=script&lang=js"
export * from "./IconUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports